import React from "react";
import { useLang } from "@/lib/i18n";
import SeoLandingPage from "@/components/SeoLandingPage";
import { mobieleTruckwashNL } from "@/data/seo-landing-pages";

const MobieleTruckwashNederland = () => {
  const { lang } = useLang();
  return <SeoLandingPage data={mobieleTruckwashNL} lang={lang} />;
};

export default MobieleTruckwashNederland;
